import React from 'react';
import { FormattedMessage } from 'react-intl';

export const UnpaidAccountBanner = () => (
  <div className="banner">
    <FormattedMessage
      id="banner.unpaid.message"
      tagName="p"
      defaultMessage="Uh oh! We are unable to process payment for your upcoming membership month, and your account has been paused temporarily. Please contact your financial institution or update your payment details to reactivate your membership and keep working out!"
    />
    <p className="mb0">
      <a href="/settings/billing">
        <FormattedMessage id="banner.unpaid.update" defaultMessage="Update your information" />
      </a>
    </p>
  </div>
);
